import { Repository, Role, Team } from '@basehub/data/replicache/index'
import {
  PublicRepo,
  PublicTeam,
  isUserTeam,
} from '@basehub/data/replicache/mutators/_public-types'
import {
  isInviteExpired,
  isInviteGeneric,
} from '@basehub/data/replicache/mutators/team-space/invite-util'

export const useGenericInvite = (
  params:
    | { repo: Repository | PublicRepo | null }
    | { team: Team | PublicTeam | null; role: Role }
) => {
  if ('team' in params) {
    const { team } = params
    if (!isUserTeam(team)) return null
    return team.invites.find(
      (i) => isInviteGeneric(i) && !isInviteExpired(i) && i.role === params.role
    )
  }

  if ('repo' in params) {
    const { repo } = params
    if (!repo?.guests) return null
    return repo.guests.invites.find(
      (i) => isInviteGeneric(i) && !isInviteExpired(i)
    )
  }

  return null
}
